import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { CoreEnums } from '@/utils/domain/constants';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';

const { BaseFilters, IsActiveFilter } = Filters;

export const getUserRoleOptions = () =>
  Object.values(CoreEnums.UserRole)
    .map((value) => ({
      value,
      label: `global.role.${value}`,
      locale: true,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

const RoleFilter = {
  remote: false,
  lazy: false,
  type: 'select',
  name: 'role',
  label: 'users.form.role',
  locale: true,
  labelInValue: false,
  allowClear: true,
  needsQuotes: true,
  options: getUserRoleOptions(),
};

const TwoFactorEnabledFilter = {
  ...BaseFilters.BooleanFilter,
  name: 'userTwoFactorEnabled',
  oDataField: 'user/twoFactorEnabled',
  label: 'users.form.twoFactorEnabled',
  options: [
    {
      label: 'global.text.enabled',
      value: 'true',
      locale: true,
    },
    {
      label: 'global.text.disabled',
      value: 'false',
      locale: true,
    },
  ],
  valueTransform: (value) => value === 'true',
};

const AccessTypeFilter = {
  ...BaseFilters.EnumFilter,
  name: 'accessType',
  label: 'users.form.accessType',
  enumNamespace: getEnumNamespace(CoreEnums.UserAccessType),
  enumSource: CoreEnums.UserAccessType,
  options: createEnumOptions(CoreEnums.UserAccessType, 'users'),
};

const PositionFilter = {
  ...BaseFilters.RemoteFilter,
  name: 'positionId',
  label: 'users.form.positionId',
  knownType: CoreEnums.FormFieldType.InternalEntity,
  apiRoute: 'position/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

const AreaFilter = {
  ...BaseFilters.RemoteFilter,
  name: 'areaId',
  label: 'global.text.area',
  knownType: CoreEnums.FormFieldType.InternalEntity,
  apiRoute: 'area/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

const BossFilter = {
  ...Filters.UserFilter,
  name: 'userBossId',
  label: 'users.form.userBossId',
  labelInValue: true,
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
};

export const filtersConfig = [
  RoleFilter,
  PositionFilter,
  AreaFilter,
  BossFilter,
  TwoFactorEnabledFilter,
  AccessTypeFilter,
  IsActiveFilter,
  CreatedDateFilter,
  UpdatedDateFilter,
];

registerModuleFilters('users', filtersConfig);
